import styled from "styled-components";

export const ContainerStyled = styled.main`
  width: 100%;
  height: 100%;
  background: #252525;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;

export const ContainerContact = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;

  @media (max-width: 950px) {
    flex-direction: column;
  }
`;

export const ContactInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  img {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    width: 200px;
  }

  h2 {
    font: 700 1rem "Roboto", sans-serif;
    color: #a2a2a2;
    max-width: 400px;
    text-align: center;
  }

  p {
    font: 500 1rem "Roboto", sans-serif;
    color: #a2a2a2;
    margin: 5px 0px 0px 25px;
  }
`;

export const ContactForm = styled.form`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 450px;
  background: transparent;

  h2 {
    font: 700 1.5rem "Roboto", sans-serif;
    width: 100%;
    padding: 40px 0px 20px 0px;
    align-self: flex-start;
    border-bottom: 1px solid #ccc;
    color: #fff;
    margin-bottom: 20px;
  }

  @media (max-width: 500px) {
    transition: 1.8s all;
    width: 100%;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  margin: 6px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #212121;
  border: 0;
  outline: 0;
  color: #fff;

  -webkit-box-shadow: 0 0 0 1000px #f2f2f2 inset;
  -webkit-text-fill-color: #fff;
  box-shadow: 0 0 0 1000px #212121 inset;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 150px;
  padding: 0.5rem;
  font-size: 1rem;
  color: #fff;
  resize: vertical;

  background: #212121;
  outline: 0;
  border: 0;

  &active {
    outline: 0;
  }

  &:focus {
    border-color: blue;
    outline: 0;
  }
`;

export const ButtomSubmitted = styled.button`
  font: 700 1rem "Roboto", sans-serif;
  padding: 16px 100px;
  width: 100%;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  border: 0;
  color: #fff;
  margin-top: 25px;
  border: 1px solid #4cd964;

  &:active {
    transform: translateY(4px);
  }
`;
